<template>
  <div
    class="c-conetntsRange"
    :class="{ 'c-conetntsRange-withValueText': hasValueText }"
  >
    <div
      class="c-conetntsRange_prefix"
      v-if="$util.hasPath(requestItem, 'optionJson.range.left')"
    >
      {{ requestItem.optionJson.range.left }}
    </div>
    <div class="c-conetntsRange_slider">
      <c-slider
        type="request-detail"
        :dotSize="20"
        height="6"
        :bgStyle="BG_STYLE"
        :processStyle="PROCESS_STYLE"
        :piecewiseStyle="PIECEWISE_STYLE"
        :piecewiseActiveStyle="PIECEWISE_ACTIVE_STYLE"
        :values="sliderValues"
        :min="minValue"
        :max="maxValue"
        v-model="selectedValue"
      />
    </div>
    <div
      class="c-conetntsRange_suffix"
      v-if="$util.hasPath(requestItem, 'optionJson.range.right')"
    >
      {{ requestItem.optionJson.range.right }}
    </div>
  </div>
</template>
<script>
import { find } from 'lodash-es'
import CSlider from '~/components/molecules/CSlider'

const BG_STYLE = {
  backgroundColor: '#ddd'
}

const PROCESS_STYLE = {
  backgroundColor: '#ddd'
}

const PIECEWISE_STYLE = {
  visibility: 'visible',
  width: '2px',
  height: '12px',
  backgroundColor: '#ddd'
}

const PIECEWISE_ACTIVE_STYLE = {
  backgroundColor: '#ddd'
}

export default {
  name: 'ConetntsRange',
  components: {
    CSlider
  },
  props: {
    requestItem: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      BG_STYLE,
      PROCESS_STYLE,
      PIECEWISE_STYLE,
      PIECEWISE_ACTIVE_STYLE,
      sliderValues: [],
      selectedValue: 3 // 3がデフォルト値
    }
  },
  watch: {
    selectedValue: {
      handler() {
        this.$emit('change', {
          name: this.requestItem.name,
          value: this.selectedValue,
          isValid: true // UI上選択解除できないため常にtrue
        })
      },
      immediate: true
    }
  },
  created() {
    this.sliderValues = this.requestItem.selectItemsList.map(item => ({
      value: item.value,
      text: item.label
    }))
  },
  computed: {
    hasValueText() {
      return find(this.sliderValues, 'text')
    },
    minValue() {
      return this.sliderValues[0].value
    },
    maxValue() {
      return this.sliderValues[this.sliderValues.length - 1].value
    }
  }
}
</script>
<style lang="scss" scoped>
@media (max-width: breakpoint(Requests, M)) {
  .c-conetntsRange {
    position: relative;

    &-withValueText {
      margin-top: 40px;

      &::before {
        position: absolute;
        top: -28px;
        left: -4px;
        width: calc(100vw - 16px);
        height: 16px;
        background-color: $color-gray-50;
        content: '';
      }
    }

    &_prefix,
    &_suffix {
      position: absolute;
      top: 0;
      color: $color-gray-700;
      font-weight: bold;
      font-size: 12px;
    }

    &_prefix {
      left: -2px;
      margin-right: 8px;
      text-align: right;
    }

    &_suffix {
      right: -2px;
      margin-left: 8px;
      text-align: left;
    }

    &_slider {
      padding-top: 20px;
      width: 100%;

      /deep/ .c-slider_label {
        margin-bottom: 36px;
        color: $color-gray-700;
        font-size: 12px;
      }
    }
  }
}

@media (min-width: breakpoint(Requests, M) + 1) {
  .c-conetntsRange {
    display: flex;

    align-items: center;

    &-withValueText {
      margin-top: 60px;
    }

    &_prefix,
    &_suffix {
      flex: 0 0 80px;
      color: $color-gray-700;
      font-weight: bold;
      font-size: 14px;
    }

    &_prefix {
      margin-right: 8px;
      text-align: right;
    }

    &_suffix {
      margin-left: 8px;
      text-align: left;
    }

    &_slider {
      flex: 0 0 380px;

      /deep/ .c-slider_label {
        margin-bottom: 20px;
        color: $color-gray-700;
        font-size: 14px;
      }
    }
  }
}
</style>
